import React from 'react';
import { KKP_VENTE_WIZARD_STEPS } from '../../utils/kkpVenteBriefUtils';

const KkpVenteWizardSteps = ({ currentStep, onStepChange }) => (
  <div className="kkp-vente-wizard-steps" role="tablist" aria-label="Étapes de la vente">
    {KKP_VENTE_WIZARD_STEPS.map((step, index) => {
      const isActive = index === currentStep;
      const isDone = index < currentStep;

      return (
        <button
          key={step.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={[
            'kkp-vente-wizard-steps__item',
            isActive ? 'is-active' : '',
            isDone ? 'is-done' : '',
          ].filter(Boolean).join(' ')}
          onClick={() => onStepChange?.(index)}
        >
          <span className="kkp-vente-wizard-steps__num">{index + 1}</span>
          <span className="kkp-vente-wizard-steps__label">{step.title}</span>
        </button>
      );
    })}
  </div>
);

export default KkpVenteWizardSteps;
